import React, { useEffect } from "react";

import TableData from "../../adminComponents/TableData";
import StackedBarChart from "../../adminComponents/chartComponents/StackBarChart";

import UnassignedLead from "./UnassignedLead";
import LineChart from "./chartComponents/LineChart";

import AdminAppBar from "../../adminComponents/AdminAppBar";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";





const BodPanel = () => {
  const navigate = useNavigate()
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message, {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
  return (
    <div className="w-full bg-appGrayBackground">
    <AdminAppBar/>
    <ToastContainer/>

    <div className=" flex 4xl:mx-36 3xl:mx-28 2xl:mx-32 xl:mx-6 pb-5  custom-xl:mx-24 gap-12 xl:gap-9  custom-xl:gap-10 pt-20 ">
      <div className="grid gap-10  ">
        <LineChart/>
        <div className="">

        <StackedBarChart  />
        </div>
        </div>
        <div className=" gap-10 ">
        <TableData />
      <div className="mt-10">

              <UnassignedLead/>
      </div>
       </div>
   </div>
    </div>

    
  );
};

export default BodPanel;
